import { Injectable } from "@angular/core";
import { AbstractAdapter, Adapter, IAdapter } from "@app/utils/types";
import { Good, IGood } from "@app/models/good.model";

@Injectable({
  providedIn: "root",
})
@Adapter({ classRef: Good })
export class GoodAdapter
  extends AbstractAdapter<IGood, Good>
  implements IAdapter<IGood, Good> {}
